import { TokenModel } from "./generalLoginType"



export interface LoginState {
    model:TokenModel,
    view:{
        loginStatus: boolean,
        password: string, 
    }
}

export const LoginInitialState : LoginState = {
    model:{
        id: "",
        Name: "", 
        username: "",
        role : 0,
        token:"",
        resettoken:"",
        pw_status:0,
    },
    view:{
        loginStatus: false, 
        password: "",
    }
}


export function deepCopyTableThingyState(toCopy:LoginState):LoginState{
    return {
        model:{
            ...toCopy.model,
        },
        view:{
            loginStatus:toCopy.view.loginStatus,
            password:toCopy.view.password,
        }
    }
    
}